import React, { useEffect, useState } from 'react';

// DEPENDENCIES
import { useSelector } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch, makePath } from 'functions';

// HELPERS
import { useReport } from '../helpers/getReportData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// LOCAL PARTS
import ChartFields from './ChartFields';

// MAIN COMPONENT
const ChartSidebar = () => {

  // REDUX
  const { updateGraph } = useSelector(state => state.sidebar);

  // STATE
  const [ chartData, setChartData ] = useState({});

  // CONTEXT
  const { reportID } = useReport() || {};

  // EFFECTS
  useEffect(
    () => {
      if (!updateGraph || !reportID) return;
      apiFetch({
        endpoint: ENDPOINTS.admin.reports.chart(reportID),
        loadingMessage: 'Fetching graph settings',
        errorMessage: 'Unable to find graph settings.',
        onSuccess: ({ result } = {}) => setChartData(result)
      })
    },
    [updateGraph, reportID]
  )

  // RENDER
  return (
    <Sidebar
      name="updateGraph"
      title="Update Graph"
    >
      <Sidebar.Form
        method={chartData.chart_id ? 'PUT' : 'POST'}
        endpoint={makePath(ENDPOINTS.admin.reports.chart(reportID), chartData.chart_id)}
        initialValues={chartData}
      >
        <Form.Select
          name="chart_type_id"
          label="Type"
          lookup="reportChartType"
          optionKeys={{
            value: 'chart_type_id',
            label: 'chart_type'
          }}
          required
        />
        <Form.Control
          name="chart_title"
          label="Title"
          required
        />
        <Form.Control
          name="chart_subtitle"
          label="Subtitle"
        />
        <ChartFields chartData={chartData} />
      </Sidebar.Form>
    </Sidebar>
  );
};

// CHILD COMPONENTS
const ChartSidebarButton = props => (
  <Sidebar.Button
    name="updateGraph"
    label="Update Graph"
    icon={{
      use: 'chart',
      order: 1
    }}
    size="sm"
    outline
    {...props}
  />
)
ChartSidebar.Button = ChartSidebarButton;

// EXPORT
export default ChartSidebar;
